import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {ProductSearchBarComponent} from "./product-search-bar.component";
import {ReactiveFormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {OverlayModule} from "@angular/cdk/overlay";
import {RecentSearchesModule} from "@app/presentation/components/recent-searches/recent-searches.module";
import {ButtonModule} from "@app/presentation/components/button/button.module";
import {ProductAutocompleteModule} from "@app/presentation/components/product-autocomplete/product-autocomplete.module";
import {AngularSvgIconModule} from "angular-svg-icon";

@NgModule({
  declarations: [ProductSearchBarComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    OverlayModule,
    RecentSearchesModule,
    ButtonModule,
    ProductAutocompleteModule,
    AngularSvgIconModule
  ],
  exports: [ProductSearchBarComponent],
})
export class ProductSearchBarModule { }
